import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ShoppingCart({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#shopping-cart-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.13142 0.86977C1.7296 0.769239 1.32235 1.01349 1.22182 1.41532C1.12129 1.81715 1.36554 2.22439 1.76737 2.32492L2.96826 2.62537L2.96882 2.62551C3.02262 2.63892 3.06397 2.68395 3.07227 2.74028L3.07227 2.7403L3.30984 4.35524C3.31136 4.36778 3.31319 4.38022 3.31533 4.39257L3.9775 8.89398C3.15028 9.08317 2.53277 9.82388 2.53277 10.7083C2.53277 11.7358 3.36633 12.5694 4.39388 12.5694H13.9494C14.3636 12.5694 14.6994 12.2336 14.6994 11.8194C14.6994 11.4052 14.3636 11.0694 13.9494 11.0694H4.39388C4.19476 11.0694 4.03277 10.9074 4.03277 10.7083C4.03277 10.5092 4.19476 10.3472 4.39388 10.3472H4.79675C4.82416 10.3487 4.85187 10.3487 4.8798 10.3472H11.9752C12.6794 10.3472 13.3073 9.89695 13.5305 9.22583L14.7152 5.6708L14.7152 5.67074C15.0692 4.60857 14.2785 3.51385 13.1601 3.51385H4.70221L4.5563 2.52197L4.5563 2.52195C4.45972 1.86559 3.97689 1.33119 3.33231 1.17021L3.33206 1.17015L3.33175 1.17007L2.13142 0.86977ZM4.92286 5.01385L5.48676 8.84718H11.9752C12.0355 8.84718 12.0885 8.80853 12.1071 8.75253L12.1072 8.75206L13.2921 5.19651L13.2921 5.19646C13.3221 5.10665 13.2559 5.01385 13.1601 5.01385H4.92286ZM3.7272 15.1529C4.34085 15.1529 4.83831 14.6554 4.83831 14.0418C4.83831 13.4281 4.34085 12.9307 3.7272 12.9307C3.11355 12.9307 2.61609 13.4281 2.61609 14.0418C2.61609 14.6554 3.11355 15.1529 3.7272 15.1529ZM14.1716 14.0418C14.1716 14.6554 13.6742 15.1529 13.0605 15.1529C12.4469 15.1529 11.9494 14.6554 11.9494 14.0418C11.9494 13.4281 12.4469 12.9307 13.0605 12.9307C13.6742 12.9307 14.1716 13.4281 14.1716 14.0418Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="shopping-cart-icon">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
